import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private isAuthenticatedSubject = new BehaviorSubject<boolean>(this.checkAuthStatus());
  public isAuthenticated$: Observable<boolean> = this.isAuthenticatedSubject.asObservable();

  constructor() {
    // Vérifier l'état d'authentification au démarrage
    this.checkAuthStatus();
  }

  /**
   * Vérifie si l'utilisateur est authentifié en regardant le token dans localStorage
   */
  private checkAuthStatus(): boolean {
    const token = localStorage.getItem('auth_token');
    return !!token;
  }

  /**
   * Connecte l'utilisateur en stockant le token
   */
  login(token: string): void {
    localStorage.setItem('auth_token', token);
    this.isAuthenticatedSubject.next(true);
  }

  /**
   * Déconnecte l'utilisateur en supprimant le token
   */
  logout(): void {
    localStorage.removeItem('auth_token');
    localStorage.removeItem('verification_token');
    localStorage.removeItem('phone_number');
    localStorage.removeItem('contact_id');
    this.isAuthenticatedSubject.next(false);
  }

  /**
   * Retourne l'état actuel d'authentification
   */
  isAuthenticated(): boolean {
    return this.isAuthenticatedSubject.value;
  }

  /**
   * Retourne le token d'authentification
   */
  getToken(): string | null {
    return localStorage.getItem('auth_token');
  }
}
